import bingoModalForm from './index.vue';
export default bingoModalForm;



// WEBPACK FOOTER //
// ./src/components/bingo-modal-form/index.js